import { assistantState, checkInjectAssistantJs } from './assistantMode'

export async function mountChatSidebarWebComponent({
  cardIndex,
  mode,
  initialMessage
}: {
  mode: 'sidebar-mode' | 'user-mode'
  cardIndex?: number
  initialMessage?: string
}) {
  if (!window.assistantMode) window.assistantMode = {}
  if (!window.assistantMode.params) window.assistantMode.params = {}

  const params = window.assistantMode.params as Record<string, string>
  if (cardIndex) params.cardIndex = cardIndex.toString()
  params.mode = mode

  checkInjectAssistantJs()
  await assistantState.scriptLoadPromise

  unmountChatSidebarWebComponent()

  const chatSidebarUI = document.createElement('chat-sidebar-ui')
  chatSidebarUI.id = 'chat-sidebar-ui'
  document.body.appendChild(chatSidebarUI)

  const SIDEBAR_SETTINGS = {
    DISPLAY_MODE: 'sidebar',
    CHAT_TYPE: mode,
    CARD_INDEX: cardIndex,
    AUTO_OPEN: true,
    INITIAL_MESSAGE: initialMessage
  }

  chatSidebarUI.setAttribute('settings', JSON.stringify(SIDEBAR_SETTINGS))
}

export function unmountChatSidebarWebComponent() {
  const chatSidebarUI = document.getElementById('chat-sidebar-ui')

  if (chatSidebarUI) {
    if (chatSidebarUI.shadowRoot) {
      const iframes = chatSidebarUI.shadowRoot.querySelectorAll('iframe')
      iframes.forEach((iframe) => iframe.remove())
    }

    chatSidebarUI.remove()
  }
}
